// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__A4MVl","rootSuccess":"CompleteLink_rootSuccess__1N9tj","rootFailure":"CompleteLink_rootFailure__3lw37","isDisabled":"CompleteLink_isDisabled__TVQUR"};